import { STATUS } from "@/lib/scheduling";

export const StatusBadge = ({ status, testId }) => {
  const s = STATUS[status] || { label: status, cls: "border-sage-400" };
  return <span className={`inline-block whitespace-nowrap border px-2.5 py-1 text-sm font-semibold ${s.cls}`} data-testid={testId}>{s.label}</span>;
};

export const SessionsMeter = ({ sessions, testId = "sessions-meter" }) => {
  if (!sessions) return null;
  const { limit, used, scheduled, remaining } = sessions;
  const segs = Array.from({ length: Math.max(limit, 1) }, (_, i) => (i < used ? "used" : i < used + scheduled ? "scheduled" : "open"));
  return (
    <div data-testid={testId}>
      <div className="flex gap-1" aria-hidden="true">{segs.map((s, i) => <span key={i} className={`h-2.5 flex-1 ${s === "used" ? "bg-olive-900" : s === "scheduled" ? "bg-sage-400" : "bg-sage-400/30"}`} />)}</div>
      <p className="mt-2 text-sm text-ink-500"><span className="font-semibold text-ink-900">{used} of {limit}</span> free sessions used · {scheduled} scheduled · {remaining} remaining</p>
    </div>
  );
};

export const HowBookingWorks = () => (
  <div className="surface border-l-4 border-l-olive-900 p-5" data-testid="how-booking-works">
    <p className="font-serif text-lg font-semibold">How booking works</p>
    <ol className="mt-2 space-y-1.5">
      <li><span className="font-semibold">1. You choose a time.</span> This sends a request. It does not reserve the time yet.</li>
      <li><span className="font-semibold">2. Patria confirms.</span> Your counselor or an administrator reviews the request.</li>
      <li><span className="font-semibold">3. You get an email.</span> Your appointment is set only when that confirmation arrives.</li>
    </ol>
  </div>
);
